import { FieldErrors, FieldName, FieldValues, Path } from 'react-hook-form';
import {
  ErrorMessage as FormErrorMessage,
  FieldValuesFromFieldErrors,
} from '@hookform/error-message';

export interface ErrorMessageProps<TFieldValues extends FieldValues> {
  name: Path<TFieldValues>;
  errors: FieldErrors<TFieldValues>;
}

export default function ErrorMessage<TFieldValues extends FieldValues>(
  props: ErrorMessageProps<TFieldValues>,
) {
  const { name, errors } = props;

  return (
    <FormErrorMessage
      name={
        name as unknown as FieldName<
          FieldValuesFromFieldErrors<FieldErrors<TFieldValues>>
        >
      }
      errors={errors}
    />
  );
}
